// ============================================================================
// SECURITY WARNING
// ============================================================================
// In a production environment, API keys should NEVER be hardcoded.
// Use environment variables in your CI/CD pipeline.
// ============================================================================

const getEnv = (viteValue: string | undefined, processKey: string, fallback: string): string => {
  // 1. Vite replacement (passed explicitly)
  if (typeof viteValue !== 'undefined') {
    return viteValue;
  }

  // 2. Try process.env (standard Node/Webpack fallback)
  try {
    if (typeof process !== 'undefined' && process.env && process.env[processKey]) {
      return process.env[processKey];
    }
  } catch {
    // Ignore access errors
  }

  return fallback;
};

export const firebaseConfig = {
  apiKey: getEnv((import.meta as unknown as { env: Record<string, string | undefined> }).env.VITE_FIREBASE_API_KEY, 'VITE_FIREBASE_API_KEY', ''),
  authDomain: getEnv((import.meta as unknown as { env: Record<string, string | undefined> }).env.VITE_FIREBASE_AUTH_DOMAIN, 'VITE_FIREBASE_AUTH_DOMAIN', ''),
  projectId: getEnv((import.meta as unknown as { env: Record<string, string | undefined> }).env.VITE_FIREBASE_PROJECT_ID, 'VITE_FIREBASE_PROJECT_ID', ''),
  storageBucket: getEnv((import.meta as unknown as { env: Record<string, string | undefined> }).env.VITE_FIREBASE_STORAGE_BUCKET, 'VITE_FIREBASE_STORAGE_BUCKET', ''),
  messagingSenderId: getEnv((import.meta as unknown as { env: Record<string, string | undefined> }).env.VITE_FIREBASE_MESSAGING_SENDER_ID, 'VITE_FIREBASE_MESSAGING_SENDER_ID', ''),
  appId: getEnv((import.meta as unknown as { env: Record<string, string | undefined> }).env.VITE_FIREBASE_APP_ID, 'VITE_FIREBASE_APP_ID', '')
};

// Safety Check
if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
  console.error("CRITICAL: Firebase Configuration missing. Please check your .env file or ensure .env.local is populated correctly.");
}
